module.exports = __webpack_public_path__ + "img/solution5.d7c66685.png";